import { fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import { setCredentials } from '../store/reducers/auth';

export function createAuthBaseQuery(baseUrl: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  const rawBase = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    const result = await rawBase(args, api, extraOptions);
    if (result.error) {
      const status = result.error.status;
      // Token inválido/expirado: limpa a sessão e manda para o login em vez de travar
      // a tela com "token inválido". Assim, reabrir a página ou F5 sempre entra.
      if (status === 401) {
        try { localStorage.removeItem('midia_auth'); } catch {}
        api.dispatch(setCredentials({ user: null, token: null }));
        if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
          window.location.assign('/login');
        }
        return result;
      }
      if (status === 502 || status === 503 || status === 504) {
        return {
          error: {
            status,
            data: 'Servidor temporariamente indisponível. Tente novamente em instantes.',
          } as FetchBaseQueryError,
        };
      }
    }
    return result;
  };
}
